export class ProfileData {
    firstEdit?: [];
    name?: string;
    email?: string;
    phoneNumber?: string;
    dateOfBirth?: string;
}